import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { Button } from "@mui/material";


interface ISliderArrowProps {
    align: 'left' | 'right';
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    disabled?: boolean;
}


const Arrow: React.FC<ISliderArrowProps> = ({
    align,
    onClick,
    disabled = false
}) => {
    let className = `${align}`;
    
    if (disabled) {
        className = `${className} disabled`;
    }

    return <Button onClick={disabled ? undefined : onClick} className={`arrow ${className}`}>
        {
            align === 'left' ? (
                <KeyboardArrowLeft />
            ) : (
                <KeyboardArrowRight />
            )
        }
    </Button>;
}

export default Arrow;